import {
  TableContainer,
  Th,
  Thead,
  useDisclosure,
  MenuButton,
  Box
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link,useParams } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { useAlertContext } from '../../../../context/AlertProvider';
import { useSideNavContext } from '../../../../context/SideNavProvider';
import CustomAlert from '../../../CustomAlert/CustomAlert';
import { useApi } from '../../../../context/ApiProvider';
import { DataTable } from '../../../DataTable/DataTable';
import IconComponent from '../../../IconComponent/IconComponent';
import { TenantInterface, TenantSimplifiedInterface } from '../../../../shared/type/tenant.type';


export const RemovedUsers = () => {

type RemovedUserType = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

const columnHelper = createColumnHelper<RemovedUserType>();

const defaultAlert = {
  isOpen: false,
  id: 0,
  name: ''
};

  const { id: tenantId } = useParams();
  const { toggleShowNav } = useSideNavContext();
  const { apiTenantParentController,apiTenantUserController } = useApi();
  const { isOpen, onClose } = useDisclosure();
  const { setShow: setShowAlert, setAlertProperties } = useAlertContext();
  const [consumerData, setConsumerData] = useState<RemovedUserType[] | []>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [deleteElement, setDeleteElement] = useState<{
    isOpen: boolean;
    id: number;
    name: string;
  }>(defaultAlert);


  const columns = [
    columnHelper.accessor('firstName', {
      cell: (info) => {
        const { firstName } = info.row.original;
        const name = info.getValue();
        return <div className="text-sm font-medium">{firstName}</div>;
      },
      header: 'Imię'
    }),
    columnHelper.accessor('lastName', {
      cell: (info) => {
        const { lastName } = info.row.original;
        const name = info.getValue();
        return <div className="text-sm font-medium">{lastName}</div>;
      },
      header: 'Nazwisko'
    }),
    columnHelper.accessor('email', {
      cell: (info) => {
        const { email } = info.row.original;
        const name = info.getValue();
        return <div className="text-sm font-medium">{email}</div>;
      },
      header: 'Login'
    }),
    columnHelper.accessor('id', {
      cell: (info) => {
        const { id, firstName, lastName } = info.row.original;
        return (
          <div>
            <button
              onClick={() => {
                  setDeleteElement({
                    id: Number(id),
                    name: firstName,
                    isOpen: true
                  });
                }}
              className="font-semibold text-sm text-grayLight-600 bg-transparent border-none">
              Przywróć
            </button>
          </div>
        );
      },
      header: ''
    })
  ];

  const fetchRemovedUsers = async () => {
    try {
      const response: AxiosResponse<any, RemovedUserType[]> =
      await apiTenantParentController('archive').get(`/${tenantId}`);
      return response.data;
    } catch (error) {
      console.warn(error);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

   const fetchData = async () => {
      try {
        const miniResponse = await fetchRemovedUsers();
        setConsumerData(miniResponse);
      } catch (error) {
        console.warn(error);
      } finally {
        setIsLoading(false);
      }
    };

  const handleClose = () => {
    onClose();
    fetchData();
  };

  useEffect(() => {
    //set as true because we don't have button to unhide sidenav
    toggleShowNav(true);
    fetchData();
  }, []);

  return (
    <div className="Branches__tableContainer h-full flex flex-col justify-start lg:p-spacing-4xl">
      <TableContainer
        h={800}
        overflowY="scroll"
        className="Branches__table lg:p-spacing-3xl  bg-white rounded-lg">
        <DataTable
          data={consumerData}
          columns={columns}
          isLoading={isLoading}
          extraThead={
            <Thead>
              <Th colSpan={columns.length}>
                <div className="w-full flex items-center justify-between">
                  <p className="text-base font-semibold">Lista usuniętych użytkowników</p>
                  <div className="hidden lg:block">
                  </div>
                </div>
              </Th>
            </Thead>
          }
        />
      </TableContainer>
      <CustomAlert
        handleOpen={deleteElement.isOpen}
        icon={<IconComponent iconName="trash" />}
        header={`Przywrócić użytkownika ${deleteElement?.name}?`}
        content="Przywrócenie."
        cancelButtonText="Anuluj"
        confirmButtonText="Przywróć"
        cancelButton={{
          iconPosition: 'onlyText',
          size: 'lg',
          hierarchy: 'secondaryGray'
        }}
        confirmButton={{
          iconPosition: 'onlyText',
          size: 'lg',
          hierarchy: 'primary'
        }}
        onCancelAction={() => {
          setDeleteElement(defaultAlert);
        }}
        onConfirmAction={async () => {
          try {
            await apiTenantUserController('unarchive')
              .post('', null, {
                      params: {
                        userId: deleteElement?.id,
                      }
                    });
            setAlertProperties({
              status: 'success',
              title: 'Poprawnie przywrócono użytkownika',
              timeout: 9000
            });
          } catch (error) {
            setAlertProperties({
              status: 'error',
              title: 'Błąd przywracania użytkownika',
              timeout: 9000
            });
          } finally {
            setShowAlert(true);
            fetchData();
            setDeleteElement(defaultAlert);
          }
        }}
      />
    </div>
  );
};

